var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"rounded":"sm"}},[_c('b-card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Credenciamentos")])]),_c('b-container')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }